module.exports = __webpack_public_path__ + "img/hero-mobile-bg-effect.b7a0f2e6.png";